import {TaxInvoiceListElementType, TaxInvoiceListMapType} from "../interface";
import {PaginationMain} from "../../../../components/common/pagination/PaginationMain";
import EmptyTableRow from "../../../common/EmptyTableRow";
import {useDeleteTaxIssue} from "../hooks/useDeleteTaxIssue";
import {Dispatch, SetStateAction} from "react";
import {useUpdateTaxProgress} from "../hooks/useUpdateTaxProgress";
import DisplayNumber from "../../../../components/common/number/DisplayNumber";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";
import {useUser} from "../../../../util/userContext/UserContext";
import {useModal} from "../../../../hooks"; // 내부수정: 모달 추가

interface PropsType {
    tax: TaxInvoiceListMapType,
    selectedItems: TaxInvoiceListElementType[]
    setSelectedItems: Dispatch<SetStateAction<TaxInvoiceListElementType[]>>
}

export default function List({tax, selectedItems, setSelectedItems}: PropsType) {
    const taxList = tax.list ?? []
    const taxTotalCount = tax.totalCount ?? 0

    const isAllCheck = taxList.length !== 0 && taxList.every(el => selectedItems.map(el2 => el2.newShipmentTaxId).includes(el.newShipmentTaxId))

    const closeCallback = () => setSelectedItems([])
    const {mutate: mutateDeleteTaxIssue} = useDeleteTaxIssue({closeCallback: closeCallback})
    const {mutate: mutateUpdateTaxProgress} = useUpdateTaxProgress({closeCallback: closeCallback})

    const clickAllCheck = () => {
        if (isAllCheck) {
            const list = selectedItems.filter(el => !taxList.includes(el))

            setSelectedItems(list)
        } else {
            // @ts-ignore
            const list = [...new Set([...selectedItems, ...taxList])]

            setSelectedItems(list)
        }
    }

    const {handleModal} = useModal()
    const {user} = useUser()
    const clickCheck = (el: TaxInvoiceListElementType) => {
        // <AuthorityChecker authorityNames={['taxWriteYn']}>
        if (user?.authority.taxWriteYn === "Y") {
            if (selectedItems.includes(el)) {
                const list = selectedItems.filter(el2 => el.newShipmentTaxId !== el2.newShipmentTaxId)

                setSelectedItems(list)
            } else {
                setSelectedItems([...selectedItems, el])
            }
        }
    }

    // TODO: 세금계산서 목록 엑셀 내보내기
    const btnExportExcel = () => {
        alert("WIP")
    }

    // 내부수정: 합계 모달 추가
    const btnRequestPublishTaxInvoiceCancel = () => {
        //const list = selectedItems.map(el => ({id: el.newShipmentTaxId}))
        //mutateDeleteTaxIssue(list)
        const count = selectedItems.length
        const totalSum = selectedItems.reduce((acc, el) => acc + (el.totalAmount ?? 0), 0)

        handleModal({
            isOpen: true,
            contents: `총 ${count}건 ${totalSum.toLocaleString()}원\n발행요청 취소하시겠습니까?`,
            type: "confirm",
            callback: () => {
                const list = selectedItems.map(el => ({id: el.newShipmentTaxId}))
                mutateDeleteTaxIssue(list)
            }
        })
    }
    const btnPublishTaxInvoice = () => {
        //const list = selectedItems.map(el => ({...el, taxFlag: "Y"}))
        //mutateUpdateTaxProgress(list)
        const count = selectedItems.length
        const totalSum = selectedItems.reduce((acc, el) => acc + (el.totalAmount ?? 0), 0)

        handleModal({
            isOpen: true,
            contents: `총 ${count}건 ${totalSum.toLocaleString()}원\n발행 처리하시겠습니까?`,
            type: "confirm",
            callback: () => {
                const list = selectedItems.map(el => ({...el, taxFlag: "Y"}))
                mutateUpdateTaxProgress(list)
            }
        })
    }
    const btnPublishTaxInvoiceCancel = () => {
        //const list = selectedItems.map(el => ({...el, taxFlag: "N"}))
        //mutateUpdateTaxProgress(list)
        const count = selectedItems.length
        const totalSum = selectedItems.reduce((acc, el) => acc + (el.totalAmount ?? 0), 0)

        handleModal({
            isOpen: true,
            contents: `총 ${count}건 ${totalSum.toLocaleString()}원\n발행 취소하시겠습니까?`,
            type: "confirm",
            callback: () => {
                const list = selectedItems.map(el => ({...el, taxFlag: "N"}))
                mutateUpdateTaxProgress(list)
            }
        })
    }

    // 선택된 항목이 없거나, 선택된 항목 중에 상태가 Y(발행)인게 있으면 발행요청 취소 및 발행 버튼 비활성화
    const isSomeN = selectedItems.length === 0 || selectedItems.some(el => el.taxFlag === "Y")

    // 선택된 항목이 없거나, 선택된 항목 중에 상태가 N(발행 요청)인게 있으면 발행 취소 버튼 비활성화
    const isEveryY = selectedItems.length === 0 || selectedItems.some(el => el.taxFlag === "N")

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">세금계산서 목록(<span>{taxTotalCount}</span>건)</h6>
            <div className="table_toolbar">
                {/*
                <button className="btn btn-dark w-150px px-0" onClick={btnExportExcel}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt=""/>엑셀 내보내기
                </button> */}
                <AuthorityChecker authorityNames={['taxWriteYn']}>
                    <button className="btn btn-outline-primary ms-40px" onClick={btnRequestPublishTaxInvoiceCancel}
                            disabled={isSomeN}>
                        발행요청 취소
                    </button>
                    <button className="btn btn-primary w-80px" onClick={btnPublishTaxInvoice} disabled={isSomeN}>발행
                    </button>
                    <button className="btn btn-outline-info color2 w-80px px-0" onClick={btnPublishTaxInvoiceCancel}
                            disabled={isEveryY}>발행취소
                    </button>
                </AuthorityChecker>
            </div>
        </div>

        <table className="table table-bordered my_table" style={{tableLayout: "fixed", width: "100%"}}>
            <thead>
            <tr>
                <AuthorityChecker authorityNames={['taxWriteYn']}>
                    <th style={{width: "3%"}}>
                        <div className="checkbox_outer">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isAllCheck}
                                onClick={clickAllCheck}
                            />
                        </div>
                    </th>
                </AuthorityChecker>
                <th style={{width: "6%"}}>세금계산서<br/>발행일자</th>
                <th style={{width: "4%"}}>발행구분</th>
                <th style={{width: "5%"}}>담당자</th>
                <th style={{width: "13%"}}>매출처</th>
                <th style={{
                    width: "13%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}>이메일
                </th>
                <th style={{width: "10%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>비고</th>
                
                {/*
                <th style={{
                    width: "10%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}>마감번호
                </th> */}
                <th style={{width: "7%"}}>공급가액</th>
                <th style={{width: "6%"}}>부가세</th>
                <th style={{width: "7%"}}>금액</th>
                <th style={{width: "5%"}}>상태</th>
            </tr>
            </thead>
            <tbody>
            {taxList.length !== 0 ?
                taxList.map(el =>
                    <tr className={`clickable ${selectedItems.map(el => el.newShipmentTaxId).includes(el.newShipmentTaxId) ? "lightblue" : ""}`}
                        onClick={() => clickCheck(el)}>
                        <AuthorityChecker authorityNames={['taxWriteYn']}>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={selectedItems.map(el => el.newShipmentTaxId).includes(el.newShipmentTaxId)}
                                    />
                                </div>
                            </td>
                        </AuthorityChecker>
                        <td className="text-center">{el.issueDate}</td>
                        <td className="text-center">{el.taxNo?.startsWith("TC") ? "합산" : "개별"}</td>
                        <td className="text-center">{el.owningUserName}</td>
                        <td className="text-center">{el.customerName}</td>
                        <td className="text-center">{el.taxEmail}</td>
                        <td className="text-center">{el.remark}</td>
                        {/* <td className="text-center">{el.endNo}</td> */}
                        <td className="text-end"><DisplayNumber value={el.newDAmount}/></td>
                        <td className="text-end"><DisplayNumber value={el.taxTotal}/></td>
                        <td className="text-end"><DisplayNumber value={el.totalAmount}/></td>
                        <td className="text-center">{el.taxState}</td>
                    </tr>
                )
                : <EmptyTableRow colSpan={11}/>
            }

            {/* 내부수정: 선택 합계 행 */}
            {selectedItems.length > 0 &&
                <tr className="summary_row">
                    <td colSpan={7} className="text-end" style={{borderRight: "none"}}>
                        선택 합계 ({selectedItems.length}건)
                    </td>
                    <td className="text-end">
                        <DisplayNumber value={selectedItems.reduce((acc, el) => acc + (el.newDAmount ?? 0), 0)}/>
                    </td>
                    <td className="text-end">
                        <DisplayNumber value={selectedItems.reduce((acc, el) => acc + (el.taxTotal ?? 0), 0)}/>
                    </td>
                    <td className="text-end">
                        <DisplayNumber value={selectedItems.reduce((acc, el) => acc + (el.totalAmount ?? 0), 0)}/>
                    </td>
                    <td></td>
                </tr>
            }
            </tbody>
        </table>

        <PaginationMain totalCount={taxTotalCount}/>
    </div>
}